export class VisMerElement extends HTMLElement {
  #button

  connectedCallback() {
    if (this.children.length > this.grense) {
      const sheet = new CSSStyleSheet()
      sheet.replaceSync(`
      button { 
        display: block; 
        padding: 0; 
        border: none; 
        background: none; 
        font-family: inherit; 
        color: inherit; 
        font-size: inherit; 
        line-height: inherit; 
      }
      
      :host([data-expanded]) button {
        display: none;      
      }
      
      :host(:not([data-expanded])) ::slotted(*:nth-child(n + 2)) {
        display: none;
      }    
      `)

      const shadow = this.attachShadow({ mode: 'open' })
      shadow.adoptedStyleSheets = [sheet]
      const button = document.createElement('button')
      const antall = this.children.length - 1
      button.innerText = `+${antall} til`
      button.setAttribute('aria-label', `Se ${antall} bidragsytere til`)
      const slot = document.createElement('slot')
      shadow.appendChild(slot)
      shadow.appendChild(button)

      button.addEventListener('click', this.#handleClick)

      this.#button = button
    }
  }

  disconnectedCallback() {
    this.#button.removeEventListener('click', this.#handleClick)
  }

  #handleClick = () => {
    this.setAttribute('data-expanded', 'true')
    const nextElement = this.children[1] as HTMLElement
    nextElement.setAttribute('tabindex', '-1')
    nextElement.focus()
  }

  get grense() {
    return parseInt(this.dataset.grense ?? '3')
  }
}
